import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PasswordResetOverride from 'Overrides/Authentication/PasswordReset';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import AuthTotp from './Layouts/AuthTotp';
import AuthTotpOverride from './Layouts/AuthTotp/MetaOverrideSet';
import PasswordResetEmailFormLayout
  from '../../../PasswordResetEmailForm/Content/Content/Layouts/PasswordResetEmailFormLayout';
import { useSetNewPasswordContext } from '../SetNewPasswordContext';
import User from './Layouts/User';
import MultiFactorAuth from './Layouts/MultiFactorAuth';
import MultiFactorAuthOverride from './Layouts/MultiFactorAuth/MetaOverrideSet';
import SetNewPassword from './Layouts/SetNewPassword';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(0, 2),
  },
  form: {
    padding: 0,
  },
});

const AUTH_LAYOUTS = {
  authLogin: 'AuthPassword',
  authPasswordReset: 'AuthPasswordReset',
  authMultiFactor: 'AuthPasswordResetMultiFactor',
  authPasswordResetEmail: 'AuthPasswordResetEmail',
  authPasswordResetEmailConfirmation: 'AuthPasswordResetEmailConfirmation',
  authTotp: 'AuthPasswordResetTotp',
  user: 'user',
};

const getLayout = (headResourceType) => {
  switch (headResourceType) {
    case AUTH_LAYOUTS.user:
      return { layout: User };
    case AUTH_LAYOUTS.authMultiFactor:
      return {
        layout: MultiFactorAuth,
        metaOverrideSet: MultiFactorAuthOverride,
      };
    case AUTH_LAYOUTS.authPasswordReset:
      return {
        layout: SetNewPassword,
        metaOverrideSet: PasswordResetOverride,
      };
    case AUTH_LAYOUTS.authPasswordResetEmail:
      return {
        layout: PasswordResetEmailFormLayout,
        metaOverrideSet: PasswordResetOverride,
      };
    case AUTH_LAYOUTS.authPasswordResetEmailConfirmation:
      return {
        layout: PasswordResetEmailFormLayout,
        metaOverrideSet: PasswordResetOverride,
      };
    case AUTH_LAYOUTS.authTotp:
      return {
        layout: AuthTotp,
        metaOverrideSet: AuthTotpOverride,
      };
    default:
      return { layout: () => null };
  }
};

const FormHolder = ({
  className,
  classes,
}) => {
  const { authCollection, handleSubmit } = useSetNewPasswordContext();
  const authResource = authCollection?.resources().head();
  const { layout, metaOverrideSet } = getLayout(authResource?.type());

  return (
    <MetaCollectionFormInline
      classes={{
        root: classNames(classes.root, className),
        form: classes.form,
      }}
      collection={authCollection}
      metaOverrideSet={metaOverrideSet}
      FormProps={{
        layout,
        LayoutProps: {
          onlyUnsourcedErrors: true,
          showRemainingFieldList: false,
          hideErrorList: true,
        },
        readonly: true, // <--- Hides default Submit button
        onSubmit: (coll) => {
          handleSubmit(coll);
        },
      }}
    />
  );
};

FormHolder.defaultProps = {
  className: '',
};

FormHolder.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormHolder);
